import PropTypes from "prop-types"
import { useState, createContext, useContext, useMemo } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const authValue = useMemo(() => {
    const login = () => {
      const token = localStorage.getItem("accessToken");
      setUser(token);
    };

    const logout = () => {
      setUser(null);
    };

    return { user, login, logout };
  }, [user]);

  return (
    <AuthContext.Provider value={authValue}>
      {children}
    </AuthContext.Provider>
  );
};


AuthProvider.propTypes = {
  children: PropTypes.any
}
export const useAuth = () => {
  return useContext(AuthContext);
};
